<script setup>
import useNickname, {USE_NICKNAME_KEY} from "./NicknameComposition";
import {inject, onMounted, ref} from "vue";
const siteUrl = document.querySelector('meta[name="site-url"]').content;
const composition = inject(USE_NICKNAME_KEY, useNickname(siteUrl));

const props = defineProps({
  isLogin: {
    type: Boolean,
    default: false
  }
});

// 選択肢表示切替
const isShow = ref(false);

// 追加モード
const appendMode = ref(false);

// 追加名前
const appendName = ref('');

// ニックネーム追加
const appendNickname = async() => {
  // 追加前のニックネーム数を控えておく
  const beforeLength = composition.state.nicknames.length;

  // ニックネーム追加
  await composition.appendNickname(appendName.value);

  // 追加後のニックネーム数が増えていれば、追加モードを解除し、id が最大のニックネームを選択する
  if (composition.state.nicknames.length > beforeLength) {
    // 追加モードを解除
    appendMode.value = false;

    // 追加名前を初期化
    appendName.value = '';

    // id が最大のニックネームを選択する
    composition.useNickname(composition.state.nicknames.reduce((a, b) => a.id > b.id ? a : b).id);
  }
};

onMounted(() => {
  composition.init();

  // 疑似セレクトボックス外の要素をクリックした際、疑似セレクトボックスを非表示にする、
  document.addEventListener('click', (event) => {
    if ( ! event.target.closest('.modSelectTrigger')) {
      isShow.value = false;
    }
  });
});
</script>

<template>
  <div>
    <div v-if="isLogin">
      <p
        v-for="error in composition.state.errors"
        class="lyMb8 pFont12 pFontMedium pFontRed"
      >{{error}}</p>
    </div>
    <div :class="{modSelectTrigger: true, isShow}">
      <teleport to="body">
        <div :class="{gbModalBack: true, gbTriggerModalBack: true, isShow}"></div>
      </teleport>
      <div class="lyHorizontalBw">
        <input
          v-if="appendMode"
          v-model="appendName"
          type="text"
          name="nickname"
          placeholder=" "
          class="lyW100 lyPt16 lyPb16 lyPl8 lyPr8 pBackColorWhite pBorderRadius2px lyTextLeft"
        >
        <button
          v-if="appendMode"
          :style="'white-space:nowrap;color:#66cc66;border:1px solid #66cc66;background-color:#fff;visibility:'+(appendName.length > 0 ? 'visible' : 'hidden')"
          type="button"
          class="lyShrinkNone lyPt12 lyPb12 lyPr8 lyPl8 lyMl8 pFont14 pFontBlack pBorder1pxSolidBlack pBorderRadius2px lyTextLeft"
          @click="appendNickname"
        >登録</button>
        <button
          v-if="appendMode"
          type="button"
          class="lyHvCnt lyColumn lyW48px lyH48px pFont10 pFontBold lyTextLeft"
          @click="appendMode = false, appendName = '', isShow = false"
        >
        <span class="lyBlock lyW24px"><img
          :src="siteUrl+'images/iconClose.svg'"
          loading="lazy"
          alt=""
          width="30"
          height="31"
        ></span>
        </button>
        <button
          v-if=" ! appendMode"
          type="button"
          class="lyW100 lyPt16 lyPb16 lyPl8 lyPr8 pBackColorWhite pBorderRadius2px lyTextLeft"
          style="cursor: pointer"
          @click="isShow = true"
        >{{composition.nickname.value}}</button>
      </div>
      <div class="modSelectListContainer">
        <ul class="modSelectList">
          <li
            v-for="nickname in composition.state.nicknames"
            :key="nickname.id"
            class="pBorderBottom1pxSolidGray4"
          >
            <button
              type="button"
              class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation"
              @click="composition.useNickname(nickname.id), isShow = false"
            >{{nickname.name}}</button>
          </li>
          <li>
            <button
              type="button"
              class="lyW100 lyPt12 lyPb12 lyPr8 lyPl8 lyTextCnt pFontBold pHoverBackGray4 pAnimation"
              @click="appendMode = true, isShow = false"
            >新規追加</button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
